export interface ZephyrTestCase {
  id: string;
  key: string;
  name: string;
  status: string;
}

export interface ZephyrFolder {
  id: string;
  name: string;
  testCases: ZephyrTestCase[];
  children: ZephyrFolder[];
}

export interface ZephyrFolderRecord {
  id: number | string;
  parentId: number | string | null;
  name: string;
  index?: number;
}

interface ZephyrFolderNode extends ZephyrFolder {
  parentId: string | null;
  index: number;
}

/** Turns the flat parentId list from the folders endpoint into the tree shown on the left. */
export function buildZephyrFolderTree(records: ZephyrFolderRecord[]): ZephyrFolder[] {
  const nodes = new Map<string, ZephyrFolderNode>();
  for (const record of records) {
    if (record?.id == null || !record.name) {
      continue;
    }
    const id = String(record.id);
    nodes.set(id, {
      id,
      name: record.name,
      testCases: [],
      children: [],
      parentId: record.parentId == null ? null : String(record.parentId),
      index: record.index ?? 0,
    });
  }

  const roots: ZephyrFolderNode[] = [];
  for (const node of nodes.values()) {
    const parent = node.parentId ? nodes.get(node.parentId) : undefined;
    if (parent && parent.id !== node.id) {
      parent.children.push(node);
    } else {
      roots.push(node);
    }
  }

  sortFolderNodes(roots);
  return roots;
}

function sortFolderNodes(nodes: ZephyrFolderNode[]): void {
  nodes.sort((left, right) => left.index - right.index || left.name.localeCompare(right.name));
  for (const node of nodes) {
    sortFolderNodes(node.children as ZephyrFolderNode[]);
  }
}
